import React from 'react';
import SpamSell from './SpamSell';

const SpamSellWorker = () => <SpamSell mode="worker" />;

export default SpamSellWorker;
